import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Unsubscribe from "./pages/Unsubscribe";
import AdminDashboard from "./pages/AdminDashboard";
import DeleteAccount from "./pages/DeleteAccount";
import CommunityGuidelines from "./pages/CommunityGuidelines";
import ChildSafety from "./pages/ChildSafety";
import Support from "./pages/Support";
import Affiliates from "./pages/Affiliates";
import Referral from "./pages/Referral";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        {/* Linked from the App Store and Google Play listings */}
        <Route path="/community-guidelines" element={<CommunityGuidelines />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/support" element={<Support />} />
        <Route path="/admin" element={<AdminDashboard />} />
        {/* Partner/affiliate programme — sales pitch + live stats lookup */}
        <Route path="/affiliates" element={<Affiliates />} />
        <Route path="/partners" element={<Affiliates />} />
        <Route path="/refer/:code" element={<Referral />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
